export default __webpack_public_path__ + "static/media/ufo.4439d8a8.png";